import { Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import type { CSSProperties, JSXElementConstructor } from "react";

import { ReactComponent as DeleteIcon } from "assets/icons/common/trash.svg";
import { ReactComponent as AddNewIcon } from "legacy/assets/icons/form/add-new.svg";
import { ReactComponent as InfoIcon } from "legacy/assets/icons/form/info-outline.svg";
import { ReactComponent as LockIcon } from "legacy/assets/icons/form/lock.svg";
import { IconWrapper } from "legacy/constants/IconConstants";
import type { IconProps } from "legacy/constants/IconConstants";

export const FormIcons: {
  [id: string]: JSXElementConstructor<IconProps & { style?: CSSProperties }>;
} = {
  INFO_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <InfoIcon />
    </IconWrapper>
  ),
  HOME_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <Icon icon={IconNames.HOME} color={props.color} iconSize={props.height} />
    </IconWrapper>
  ),
  DELETE_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <DeleteIcon />
    </IconWrapper>
  ),
  ADD_NEW_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <AddNewIcon />
    </IconWrapper>
  ),
  CREATE_NEW_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <Icon icon={IconNames.PLUS} />
    </IconWrapper>
  ),
  PLUS_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <Icon icon={IconNames.PLUS} color={props.color} iconSize={props.height} />
    </IconWrapper>
  ),
  SLASH_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <Icon
        icon={IconNames.SLASH}
        color={props.color}
        iconSize={props.height}
      />
    </IconWrapper>
  ),
  LOCK_ICON: (props: IconProps) => (
    <IconWrapper {...props}>
      <LockIcon />
    </IconWrapper>
  ),
};
